// extracted by mini-css-extract-plugin
export default {"Career":"style_Career__ZUfVu","none-decoration":"style_none-decoration__RXXsx"};